import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import Footer from './components/footer';
import Header from './components/header';
import ScrollToTop from './components/ScrollToTop';
import NotFound from './pages/error/404';
import Home from './pages/home';
import Appartements from './pages/appartements';
import AppartementQuartz from './pages/appartements/quartz';
import AppartementSiderite from './pages/appartements/siderite';
import AppartementEpidote from './pages/appartements/epidote';
import FAQ from './pages/faq';
import Photos from './pages/photos';
import Contact from './pages/info/contact';
import MentionsLegales from './pages/mentions-legales';

function App() {
  return (
    <LanguageProvider>
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex flex-col flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/appartements" element={<Appartements />} />
                <Route path="/pricing" element={<Navigate to="/appartements" replace />} />
                <Route path="/about" element={<FAQ />} />
                <Route path="/photos" element={<Photos />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/appartements/appartement-2-personnes-quartz" element={<AppartementQuartz />} />
                <Route path="/appartements/appartement-4-personnes-siderite" element={<AppartementSiderite />} />
                <Route path="/appartements/appartement-6-personnes-epidote" element={<AppartementEpidote />} />
                <Route path="/appartements/quartz" element={<Navigate to="/appartements/appartement-2-personnes-quartz" replace />} />
                <Route path="/appartements/siderite" element={<Navigate to="/appartements/appartement-4-personnes-siderite" replace />} />
                <Route path="/appartements/epidote" element={<Navigate to="/appartements/appartement-6-personnes-epidote" replace />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </HelmetProvider>
    </LanguageProvider>
  );
}

export default App;
